import { Building2 } from "lucide-react";

/** Company name with a building icon, shown above the result headline. */
export const CompanyIndicator = ({
  organisationName,
}: {
  organisationName: string;
}) => (
  <div className="inline-flex items-center gap-1">
    <Building2 className="h-3 w-3 text-gray-600 shrink-0" aria-hidden />
    <span className="text-xs text-gray-600">{organisationName}</span>
  </div>
);
